import { ReportTab } from '../Api/Report/reportApi';

/** Orders a report's tabs by position, or gives a report with none its one fallback tab. */
export const resolveReportTabs = (tabs: ReportTab[] | undefined, fallback: Omit<ReportTab, 'position'>): ReportTab[] =>
  tabs?.length ? [...tabs].sort((first, second) => first.position - second.position) : [{ ...fallback, position: 0 }];
